import React from "react";
import {
  Box,
  Typography,
  Badge,
  useMediaQuery,
  useTheme,
  Modal,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import DownloadIcon from "@mui/icons-material/DownloadForOffline";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GroupIcon from "@mui/icons-material/Group";

import { useAppStore } from "../../appStore";
import Withdraw from "../Wallet/withdrawRequest/withdarwDialog";

const FloatingCard = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isAtPageBottom, setIsAtPageBottom] = React.useState(false);

  const {
    referralUserCount,
    setAddPointOpen,
    setWithdrawOpen,
    WithdrawOpen,
    profileData,
  } = useAppStore();

  React.useEffect(() => {
    if (!isMobile) return undefined;

    const updateBarStyle = () => {
      const page = document.documentElement;
      const distanceFromBottom =
        page.scrollHeight - (window.scrollY + window.innerHeight);
      setIsAtPageBottom(distanceFromBottom <= 24);
    };

    updateBarStyle();
    window.addEventListener("scroll", updateBarStyle, { passive: true });
    window.addEventListener("resize", updateBarStyle);

    return () => {
      window.removeEventListener("scroll", updateBarStyle);
      window.removeEventListener("resize", updateBarStyle);
    };
  }, [isMobile]);

  if (!isMobile) return null;

  const iconColor = "#ff6f00"; // Dark Orange

  const items = [
    {
      icon: <AccountBalanceWalletIcon sx={{ fontSize: 22, color: iconColor }} />,
      title: "Add Points",
      onClick: () => setAddPointOpen(true),
    },
    {
      icon: <DownloadIcon sx={{ fontSize: 22, color: iconColor }} />,
      title: "Withdraw",
      onClick: () => setWithdrawOpen(true),
    },
    {
      icon: <AccountBalanceIcon sx={{ fontSize: 22, color: iconColor }} />,
      title: "Bank",
      onClick: () => navigate("/profile?tab=1"),
    },
     ...(profileData?.userLoginType !== "HWL"
    ? [
        {
          icon: <GroupIcon sx={{ fontSize: 22, color: iconColor }} />,
          title: "Referrals",
          badge: referralUserCount,
          onClick: () => navigate("/profile?tab=2"),
        },
      ]
    : []),
  ];

  return (
    <>
      <Paper
        elevation={6}
        sx={{
          position: "fixed",
          bottom: 6,
          left: 8,
          right: 8,
          zIndex: 1300,
          minHeight: 58,
          borderRadius: 3,
          px: 0.75,
          py: 0.5,
          background: isAtPageBottom
            ? "linear-gradient(135deg, rgb(30,36,102), rgb(39,47,130))"
            : "linear-gradient(135deg, rgba(24,32,112,0.56), rgba(54,63,151,0.46))",
          backdropFilter: isAtPageBottom
            ? "none"
            : "blur(3px) saturate(115%)",
          WebkitBackdropFilter: isAtPageBottom
            ? "none"
            : "blur(3px) saturate(115%)",
          boxShadow: isAtPageBottom
            ? "0 4px 14px rgba(15, 23, 90, 0.3)"
            : "0 6px 20px rgba(15, 23, 90, 0.16), inset 0 1px 0 rgba(255,255,255,0.24)",
          border: isAtPageBottom
            ? "1px solid rgba(255,255,255,0.1)"
            : "1px solid rgba(255,255,255,0.3)",
          transition:
            "background 220ms ease, box-shadow 220ms ease, border-color 220ms ease",
          display: { xs: "flex", sm: "none" },
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {items.map((item, index) => (
          <Box
            key={index}
            onClick={item.onClick}
            sx={{
              cursor: "pointer",
              textAlign: "center",
              borderRadius: 1.5,
              px: 0.5,
              py: 0.5,
              minHeight: 48,
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              transition: "0.25s ease-in-out",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.12)",
              },
              "&:active": {
                backgroundColor: "rgba(255, 255, 255, 0.18)",
                transform: "scale(0.97)",
              },
            }}
          >
            <Box>
              {item.badge ? (
                <Badge badgeContent={item.badge} color="secondary">
                  {item.icon}
                </Badge>
              ) : (
                item.icon
              )}
            </Box>
            <Typography
              variant="caption"
              sx={{
                color: "#fff",
                fontSize: "0.8rem",
                lineHeight: 1.2,
                mt: 0.3,
                letterSpacing: 0.25,
                // fontWeight: 600,
                textShadow: "0 1px 3px rgba(10, 15, 60, 0.7)",
              }}
            >
              {item.title}
            </Typography>
          </Box>
        ))}
      </Paper>

      {/* Withdraw Dialog */}
      <Modal
        open={WithdrawOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100% - 24px)", sm: 360 },
            maxHeight: { xs: "calc(100dvh - 24px)", sm: "calc(100vh - 48px)" },
            boxSizing: "border-box",
            overflow: "hidden",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: { xs: 1, sm: 4 },
            borderRadius: 2,
          }}
        >
          <Withdraw />
        </Box>
      </Modal>
    </>
  );
};

export default FloatingCard;
